// extracted by mini-css-extract-plugin
export var fade = "styles-module--fade--9839b";
export var green = "styles-module--green--47615";
export var white = "styles-module--white--b25d6";
export var wrapper = "styles-module--wrapper--5dfc6";